module.exports = __webpack_public_path__ + "assets/imgs/intro.9f2f5b43e2a3c355963713b768963619.svg";